<template>
  <path
    fill="currentColor"
    d="M3 8.4a.6.6 0 1 1 0-1.2h18a.6.6 0 0 1 0 1.2H3Zm0 3.9a.6.6 0 1 1 0-1.2h18a.6.6 0 0 1 0 1.2H3Zm0 3.9A.6.6 0 1 1 3 15h18a.6.6 0 0 1 0 1.2H3Z"
  />
</template>
